module.exports = __webpack_public_path__ + "img/rainy-city-tram.8cff4732.webp";